module.exports = __webpack_public_path__ + "static/media/narudzbe.449109e5.svg";